module.exports = __webpack_public_path__ + "static/media/自動車部.19f59e43.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/exhibition/自動車部.png
// module id = 324
// module chunks = 10